function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");
var _ref3 = /*#__PURE__*/React.createElement("defs", null);
var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "1.-Desktop",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Tablet---Inzicht-stel-een-vraag",
  transform: "translate(-963.000000, -106.000000)",
  stroke: "#425cd4",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(-2.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Select-gebouw",
  transform: "translate(814.000000, 90.000000)"
}, /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-1",
  points: "161 18 157 22 153 18"
})))));
function SvgDropdownBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "8px",
    viewBox: "0 0 12 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F56D01BF-CB4C-4683-B5E7-387AF9ECC169") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownBlue);
export default __webpack_public_path__ + "static/media/Dropdown_Blue.58adba14b0ff029453d5f7734eed2c3a.svg";
export { ForwardRef as ReactComponent };